import { render, staticRenderFns } from "./Company-Split.vue?vue&type=template&id=31ba0bb5&scoped=true"
import script from "./Company-Split.vue?vue&type=script&lang=js"
export * from "./Company-Split.vue?vue&type=script&lang=js"
import style0 from "./Company-Split.vue?vue&type=style&index=0&id=31ba0bb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba0bb5",
  null
  
)

export default component.exports